import { gameLiveConnection } from './gameConnection';
import { jackpotConnection } from './jackpotConnection';

class ConnectionGroup {
  startGameConnection() {
    return new Promise(() => {
      gameLiveConnection.stop().then(() => {
        gameLiveConnection.init().then(() => {
          gameLiveConnection.sendGameGetInitialState().then(() => {});
        });
      });
    });
  }

  startJackpotConnection() {
    return new Promise((res) => {
      jackpotConnection.stop().then(() => {
        jackpotConnection.init().then(() => {
          jackpotConnection.sendGameGetInitialState();
          res({ socketPath: window.location.pathname });
        });
      });
    });
  }
}

export const connectionGroup = new ConnectionGroup();
